const COMMENTS = [
  {
    avatar: 'R',
    name: '漫画迷小七',
    time: '2小时前',
    content: '香香漫画网址太好用了！下拉式追更真的太方便了，一口气追完一部韩漫，完全停不下来。画质也很清晰，推荐给身边所有爱看漫画的朋友了！',
    likes: 328,
  },
  {
    avatar: 'M',
    name: '日漫爱好者阿琳',
    time: '5小时前',
    content: '找了好久才找到香香漫画官网入口，这里的日漫资源真的超全！很多冷门佳作都能找到，而且更新速度很快，已经安利给了整个宿舍。',
    likes: 256,
  },
  {
    avatar: 'L',
    name: '追更达人老张',
    time: '昨天',
    content: '作为十年老漫迷，用过的漫画网站不少，香香漫画是体验最好的之一。国漫板块尤其出色，很多独家作品都在这里看的。',
    likes: 189,
  },
  {
    avatar: 'Y',
    name: '颜控漫粉',
    time: '昨天',
    content: '画风控的福音！香香漫画上的韩漫画风都好好看，而且分类很细致，找自己喜欢的类型特别方便。永远支持香香漫画网！',
    likes: 412,
  },
  {
    avatar: 'S',
    name: '深夜追更的小陈',
    time: '2天前',
    content: '每天晚上都要打开香香漫画追更，已经成了习惯。下拉式阅读模式真的太爽了，不用一直点翻页，体验感直接拉满。希望平台越来越好！',
    likes: 175,
  },
];

export default function Comments() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            读者热评
          </h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-lg mx-auto">
            听听读者们怎么说 —— 真实的追更体验，来自漫画爱好者的心声
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5 md:gap-6">
          {COMMENTS.map((c, i) => (
            <div
              key={i}
              className="bg-background-50 rounded-xl border border-background-200/50 p-4 md:p-5 flex flex-col"
            >
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-primary-100 text-primary-600 font-semibold text-sm flex items-center justify-center shrink-0">
                  {c.avatar}
                </div>
                <div className="min-w-0">
                  <div className="text-sm font-semibold text-foreground-900 truncate">
                    {c.name}
                  </div>
                  <div className="text-xs text-foreground-400">{c.time}</div>
                </div>
              </div>
              <p className="mt-3 text-sm text-foreground-600 leading-relaxed flex-1">
                {c.content}
              </p>
              <div className="mt-4 flex items-center gap-1.5 text-xs text-foreground-400">
                <i className="ri-heart-line text-accent-500" />
                <span>{c.likes}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}